
// 問い合わせページ上でのフローティングボタン非表示
window.addEventListener("load", function(){
  if(location.href.match('pages/contact')) {
    // フローティングボタンの要素取得
    var sb_elem = document.getElementById("id_sb_floating_container"); 
    // ページ読み込み時のフェードイン表示を非表示に上書き
    sb_elem.style.setProperty('display', 'none', 'important');
    // 最下部スクロール後のcss追加を拒否するために、idを削除
    sb_elem.removeAttribute("id");
  }
});

